import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbCalendar, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService } from '../../Util/Toast/toast.service';
import { SessionService } from '../../Util/Session/session.service';

@Component({
  selector: 'app-get-emp-leave-mgmt-code',
  standalone: true,
  imports: [NgbModule,FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule],
  templateUrl: './get-emp-leave-mgmt-code.component.html',
  styleUrl: './get-emp-leave-mgmt-code.component.scss'
})
export class GetEmpLeaveMgmtCodeComponent {
  @Input() data: any;


  constructor(
    private sessionService: SessionService,
    private comboload : ComboService,
    private toast : ToastService,
    private modalService: NgbModal,
    private calendar: NgbCalendar,
    public activeModal: NgbActiveModal
  ){}
  
  ngOnInit(): void {
     
  }

  closeModal(result: boolean) {
    this.activeModal.close(result);
  }
}
